export default {
    invoiceByCustomerList: state => state.invoiceByCustomerList,
    invoiceByCustomerData: state => state.invoiceByCustomerData
}
